import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=08db5677&scoped=true"
import script from "./addForm.vue?vue&type=script&lang=ts"
export * from "./addForm.vue?vue&type=script&lang=ts"
import style0 from "./addForm.vue?vue&type=style&index=0&id=08db5677&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db5677",
  null
  
)

export default component.exports